export const displayPolygon = (
    areaPath,
    pathCoord,
    setZoneDisplayed,
    color,
    zIndex,
    mapData,
    mapsData,
    addListenersOnEditSiteAreaChangesPolygon,
    addListenersOnEditSiteAreaFinalPolygon,
    addListenersOnEditAreaFinalPolygon,
    polygonClick,
    polyMouseOver,
    polyMouseOut,
  ) => {
    let temp = [];
    for (let i = 0; i < areaPath.length; i++) {
      let zone =
        mapsData &&
        new mapsData.Polygon({
          paths: pathCoord[i],
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: color,
          fillOpacity: 0.15,
          indexID: areaPath[i].Id,
          zIndex: zIndex,
        });

      zone.setMap(mapData);
      temp = [...temp, zone];
      if (color === "#663a83") {
        addListenersOnEditSiteAreaChangesPolygon(zone);
        addListenersOnEditSiteAreaFinalPolygon(zone);
      } else {
        addListenersOnEditAreaFinalPolygon(zone);
      }
      polygonClick(zone);
      polyMouseOver(zone);
      polyMouseOut(zone);
    }
    setZoneDisplayed(temp);
  };